module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_smartphone_d1face9721e19d1c1c0cca7a178ee01a.png";